import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import UnsubI18nProvider from "./UnsubI18nProvider";

const Unsubscribe = lazy(() => import("./UnsubscribeIterable"));
const Confirmation = lazy(() => import("./Confirmation"));

const UnsubscriptionIterableRouter = () => {
  return (
    <Router>
      <UnsubI18nProvider>
        <Routes>
          <Route
            path="/unsubscription"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <SnackbarProvider
                  maxSnack={1}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  autoHideDuration={3000}
                  preventDuplicate
                >
                  <Unsubscribe />
                </SnackbarProvider>
              </Suspense>
            }
          />
          <Route
            path="/unsubscription/confirmation"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <SnackbarProvider
                  maxSnack={1}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  autoHideDuration={3000}
                  preventDuplicate
                >
                  <Confirmation />
                </SnackbarProvider>
              </Suspense>
            }
          />
        </Routes>
      </UnsubI18nProvider>
    </Router>
  );
};

export default UnsubscriptionIterableRouter;
